import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import ReactCropper from 'react-cropper'

import CropperTool from './cropper-tool'
import { cropperCancel, cropperSave } from 'actions/cropper'
import { getCurrentImage } from 'selectors/cropper'
import {
  CROPPER_IMAGE_WIDTH,
  CROPPER_IMAGE_HEIGHT,
  CROPPER_IMAGE_RATIO,
} from 'constants/cropper-tool-constants'

export class CropperToolContainer extends Component {

  constructor(props) {
    super(props)

    this.handleCancel = this.handleCancel.bind(this)
    this.handleSave = this.handleSave.bind(this)
  }

  getCroppedData() {
    return this.refs.cropper.getCroppedCanvas({
      width: CROPPER_IMAGE_WIDTH,
      height: CROPPER_IMAGE_HEIGHT,
    }).toDataURL()
  }

  handleCancel() {
    this.props.cropperCancel(this.props.file)
  }

  handleSave() {
    const data = this.getCroppedData()
    this.props.cropperSave(this.props.file, data)
  }

  render() {
    if (this.props.visible) {
      return (
        <CropperTool onCancel={this.handleCancel} onSave={this.handleSave}>
          <ReactCropper
            guides
            aspectRatio={CROPPER_IMAGE_RATIO}
            dragMode="move"
            ref="cropper"
            src={this.props.src}
            style={{ height: '100%', width: '100%' }}
          />
        </CropperTool>
      )
    }
    return null
  }

}

CropperToolContainer.propTypes = {
  cropperCancel: PropTypes.func,
  cropperSave: PropTypes.func,
  file: PropTypes.any,
  src: PropTypes.string,
  visible: PropTypes.bool,
}

const mapStateToProps = state => {
  const image = getCurrentImage(state.cropper.current)(state)
  const visible = state.cropper.current && !state.cropper.pendingValidation

  return {
    visible,
    src: visible ? image.src : null,
    file: visible ? image.file : null,
  }
}

const mapDispatchToProps = { cropperCancel, cropperSave }

export default connect(mapStateToProps, mapDispatchToProps)(CropperToolContainer)



/** WEBPACK FOOTER **
 ** ./src/components/cropper-tool/cropper-tool-container.js
 **/